module.exports = __webpack_public_path__ + "img/banner_leonos@2x.e20c5f63.png";